/* Space Waste motion layer — Apple/SpaceX-style scroll polish.
   Cross-browser (IntersectionObserver + rAF). Fully no-op under reduced motion
   or when IntersectionObserver is unavailable, so content is never trapped
   hidden. The full-screen tool pages use their own layouts and never load this. */
(function () {
  var doc = document;
  var root = doc.documentElement;

  // Respect reduced-motion: leave everything visible and static, do nothing.
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {}

  if (!('IntersectionObserver' in window)) return;

  /* ---- 1. Scroll reveal ------------------------------------------------ */

  var SELECTOR = [
    '.sw-stmt__inner', '.sw-eco__inner',
    '.sw-article__hook', '.sw-article__facts', '.sw-article__angle', '.sw-article__cta',
    '.sw-tools__eyebrow', '.sw-tools__heading', '.sw-tools__sub', '.sw-tool-card',
    '.sw-msup__left', '.sw-msup__right',
    '.sw-bridge__inner',
    '.sw-intro', '.sw-stat', '.sw-tech-card', '.sw-photo', '.sw-photo-grid-item', '.sw-callout',
    '.sw-phase', '.sw-goal', '.sw-navcard', '.sw-hubhead',
    '.sw-spec__mission', '.sw-spec__sheet',
    '.swr-pub', '.swr-ag', '.swr-habit', '.swr-table',
    '.prox-strip__item', '.prox-section-head', '.prox-schematic', '.prox-perf-card', '.prox-compliance',
    '.sw-adopt__hero', '.sw-adopt-card',
    '.product-card', '.card'
  ].join(',');

  // Cards scale up; the paired mission-signup columns slide in from their side.
  var SCALE_IN = '.sw-tool-card,.sw-tech-card,.sw-navcard,.sw-goal,.sw-adopt-card,.prox-perf-card,.product-card,.card';
  var SLIDE_L = '.sw-msup__left';
  var SLIDE_R = '.sw-msup__right';

  function matches(el, sel) {
    var fn = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    try { return fn ? fn.call(el, sel) : false; } catch (e) { return false; }
  }

  function setupReveal() {
    var els = Array.prototype.slice.call(doc.querySelectorAll(SELECTOR));
    if (!els.length) return;

    root.classList.add('sw-reveal-ready');

    var counts = {};
    var uid = 0;
    els.forEach(function (el) {
      el.classList.add('sw-reveal');
      if (matches(el, SLIDE_L)) el.classList.add('sw-rv-left');
      else if (matches(el, SLIDE_R)) el.classList.add('sw-rv-right');
      else if (matches(el, SCALE_IN)) el.classList.add('sw-rv-scale');

      var p = el.parentNode;
      if (!p._swid) { p._swid = ++uid; }
      var n = counts[p._swid] || 0;
      counts[p._swid] = n + 1;
      var delay = Math.min(n * 70, 280);
      if (delay) el.style.transitionDelay = delay + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sw-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 2. Count-up stats ---------------------------------------------- */

  var COUNT_SELECTOR = '.sw-stat-num,.sw-bridge__stats strong,.sw-eco__stats strong,.sw-home-hero__statline span';

  function animateCount(el) {
    var finalText = el.getAttribute('data-sw-final');
    if (finalText === null) { finalText = el.textContent; el.setAttribute('data-sw-final', finalText); }

    var m = finalText.match(/^(\D*)([\d][\d,]*\.?\d*)(.*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var hasComma = numStr.indexOf(',') > -1;
    var decimals = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target) || target < 5) return; // skip trivial values (1, etc.)

    function fmt(v) {
      var s = decimals ? v.toFixed(decimals) : Math.round(v).toString();
      if (hasComma) {
        var parts = s.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        s = parts.join('.');
      }
      return prefix + s + suffix;
    }

    var dur = 1400, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  function setupCounters() {
    var nums = Array.prototype.slice.call(doc.querySelectorAll(COUNT_SELECTOR));
    if (!nums.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---- 3. Scroll progress bar + hero parallax ------------------------- */

  function setupScrollFX() {
    var bar = doc.createElement('div');
    bar.className = 'sw-scrollbar';
    doc.body.appendChild(bar);

    var heroBg = doc.querySelector('.sw-home-hero__bg');
    var ticking = false;

    function update() {
      var st = window.pageYOffset || root.scrollTop || 0;
      var h = (root.scrollHeight - window.innerHeight);
      bar.style.width = (h > 0 ? (st / h) * 100 : 0) + '%';

      if (heroBg) {
        if (window.innerWidth > 640) {
          var y = Math.min(st * 0.15, 40);
          heroBg.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.12)';
        } else {
          heroBg.style.transform = 'scale(1.12)';
        }
      }
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- boot ------------------------------------------------------------ */

  function start() {
    setupReveal();
    setupCounters();
    setupScrollFX();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
